import React from "react";
import { grey } from "@mui/material/colors";
import { Box, Typography } from "@mui/material";
import { TableCell } from "./TableCell";
import { Column } from "../types";

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  columns: Column<Data, Context>[];
}

export const TableHead = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  context,
}: Props<Data, Context>) => (
  <Box
    sx={{
      display: "grid",
      backgroundColor: grey["300"],
      gridTemplateColumns: columns.map(column => column.width || "1fr").join(" "),
    }}>
    {columns.map((column, columnIndex) => (
      <TableCell key={`${column.header}_${columnIndex}`} column={column} context={context}>
        {column.renderHeadCell ? (
          column.renderHeadCell({
            column,
            context,
            columns,
            columnIndex,
            existingColumnsTypes: columns.map(({ columnType }) => columnType).filter(Boolean) as string[],
          })
        ) : (
          <Typography variant="subtitle2" component="span">
            {column.header}
          </Typography>
        )}
      </TableCell>
    ))}
  </Box>
);
